import { useDispatch } from "react-redux";
import { CustomAvatar } from "../components/Popups/SelectTypeCustomAvatarPopup";
import { Popups, updatePopup } from "../redux/actions/popupsActions";
import { useSelector } from "react-redux";
import { getPrefilled } from "../redux/reducers/popupsReducer";
// import { ConfirmationDelete, DeleteType } from "../types/confirmationDelete";
// import { Video } from "../types/video";

// type AvatarType = CustomAvatar | null;
// type Props = {
//   selectedAvatarType?: AvatarType;
//   handleClose: () => void;
// };

const useCustomAvatarPopupSteps = (handleClose: () => void) => {
  const { noRefresh, prefilledType } = useSelector(getPrefilled);

  // const [isBackButton, setIsBackButton] = useState(false);
  // const [step, setStep] = useState(1);

  const dispatch = useDispatch();

  const goToFirstStep = () => {
    handleClose();
    dispatch(updatePopup({ popup: Popups.selectTypeCustomAvatarPopup, status: true, prefilled: { noRefresh } }));
  };
  const goToStep2 = () => {
    //
  };
  const openTalkingImageUploader = () => {
    handleClose();
    dispatch(
      updatePopup({
        popup: Popups.addCustomAvatarPopup,
        status: true,
        prefilled: { noRefresh, type: CustomAvatar.TalkingImage },
      }),
    );
  };
  const openInstantImageGuidePopup = () => {
    handleClose();
    dispatch(
      updatePopup({
        popup: Popups.prepareRecordingEnvironmentPopup,
        status: true,
        prefilled: {},
      }),
    );
  };
  const openInstantImageUploaderPopup = () => {
    handleClose();
    dispatch(
      updatePopup({
        popup: Popups.addCustomAvatarPopup,
        status: true,
        prefilled: { noRefresh, type: CustomAvatar.InstantAvatar },
      }),
    );
  };
  // const openConfirmationPopup = (title: string, videoFile1: Video, videoFile2: Video) => {
  //   //
  //   const confirmationPrefilled: ConfirmationDelete = {
  //     id: Math.random(),
  //     title: `Ready to Submit Your Avatar?`,
  //     description: `Please review your video before submitting. Once submitted, you won't be able to make any changes.`,
  //     typeId: 1,
  //     type: DeleteType.CustomAvatarUpload,
  //     // previousFill,
  //   };
  //   dispatch(
  //     updatePopup({
  //       popup: Popups.confirmationPopup,
  //       status: true,
  //       prefilled: confirmationPrefilled,
  //     }),
  //   );
  // };
  return {
    goToFirstStep,
    openTalkingImageUploader,
    openInstantImageGuidePopup,
    openInstantImageUploaderPopup,
    // openConfirmationPopup,
  };
};

export default useCustomAvatarPopupSteps;
